/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-payments-source.js
 * Please replicate all changes to the other file.
 */

import jq from 'jquery';
import _ from 'underscore';
import { T_ } from '@shared/translation';
import { cdn_url } from '@shared/cdn';
import paymentsSourceTemplate from './payments-source.html';
import 'bootstrap';

let moduleData = false;
let $el = false;
const moduleSettings = {
  disableCC: false,
  disableBalance: false,
  showWireTransferLink: false,
};

function init(
  paymentsSourceDetails,
  paymentsSourceContainer,
  preferredSettings,
) {
  jq.extend(moduleSettings, preferredSettings);

  if (typeof paymentsSourceDetails === 'object') {
    moduleData = paymentsSourceDetails;
  } else {
    return;
  }
  if (typeof paymentsSourceContainer !== 'undefined') {
    $el = paymentsSourceContainer;
  } else {
    return;
  }
  if (!validateAndPrepareData()) {
    return;
  }
  $el.html(
    `<img src="${cdn_url('/img/ajax-loader.gif')}" ` +
      'class="loading-payment-source-module margin-center block" />',
  );
  jq.ajax({
    type: 'post',
    data: {
      currency: moduleData.currencyDetails.id,
    },
    url: '/ajax/payment/getUserPaymentMethodInfo.php',
    dataType: 'json',
    success(response) {
      if (response.status == 'success') {
        moduleData.balances = response.balances;
        moduleData.paymentMethods = response.paymentMethods;
        moduleData.firstAvailablePaymentMethod =
          response.firstAvailablePaymentMethod;
        moduleData.preferredPaymentMethod = response.preferredPaymentMethod;
        for (let i = 0; i < moduleData.balances.length; i++) {
          if (parseFloat(moduleData.balances[i].balance) > 0) {
            moduleData.totalBalanceIsEmpty = false;
            break;
          }
        }

        if (moduleSettings.disableCC) {
          removeCC();
        }

        if (moduleSettings.disableBalance) {
          removeBalance();
        }

        if (moduleSettings.showWireTransferLink) {
          includeWireTransferLink();
        }

        reconstructBalances();
        countVerifiedPaymentSource();
        render();
        buildBinds();
        checkPaymentSource(moduleData.amount);
      }
    },
    complete() {
      $el.find('.loading-payment-source-module').remove();
    },
  });
}

function removeCC() {
  moduleData.hasVerifiedCreditCard =
    moduleData.paymentMethods.gcRecurring ||
    moduleData.paymentMethods.wpRecurring;
  moduleData.removedCC = true;
  moduleData.paymentMethods.gcRecurring = false;
  moduleData.paymentMethods.wpRecurring = false;

  moduleData.preferredPaymentMethod = 'gatewayPP';
  moduleData.firstAvailablePaymentMethod = 'gatewayPP';
}

function removeBalance() {
  moduleData.balances = [];
  moduleData.totalBalanceIsEmpty = true;
}

function includeWireTransferLink() {
  moduleData.showWireTransferLink = true;
}

function validateAndPrepareData() {
  if (
    typeof moduleData.amount === 'undefined' ||
    isNaN(moduleData.amount) ||
    !moduleData.amount ||
    typeof moduleData.currencyDetails === 'undefined'
  ) {
    return false;
  }
  moduleData.amount = parseFloat(moduleData.amount);
  moduleData.primaryBalanceForPayment = false;
  moduleData.totalBalanceIsEmpty = true;
  moduleData.verifiedPaymentSourceCount = 0;
  return true;
}

function render() {
  let tpl = paymentsSourceTemplate;

  if (typeof tpl === 'undefined') {
    tpl = jq('#payment-source-template').html();
  }

  $el.html(
    _.template(tpl)({
      templateData: moduleData,
      T_,
      cdn_url,
    }),
  );
}

function checkPaymentSource(amountToCheck) {
  $el
    .find('.payment-from-option, .account-balances, .payment-logos-container')
    .hide();
  if (isNaN(amountToCheck) || !amountToCheck) {
    return;
  }

  amountToCheck = parseFloat(amountToCheck);

  if (moduleData.totalBalanceIsEmpty) {
    // If all balances are zero
    if (moduleData.firstAvailablePaymentMethod) {
      $el.find('.only-vpm, .payment-logos-container').show();
    } else {
      customizePaymentSourceNeedDepositContent();
      $el.find('.need-deposit').show();
    }
  } else if (
    moduleData.primaryBalanceForPayment &&
    amountToCheck <= moduleData.primaryBalanceForPayment.balance
  ) {
    // If primary balance is sufficient
    $el.find('.only-balance, .account-balances').show();
    // Primary balance is insufficient but not zero balances among all balances
  } else if (moduleData.firstAvailablePaymentMethod) {
    $el
      .find('.mixed-balance-vpm, .account-balances, .payment-logos-container')
      .show();
  } else if (
    moduleData.balances.length === 1 &&
    moduleData.balances[0].currency.id == moduleData.currencyDetails.id
  ) {
    customizePaymentSourceNeedDepositContent();
    $el.find('.need-deposit').show();
  } else {
    $el.find('.may-need-deposit, .account-balances').show();
  }
}

function buildBinds() {
  jq(document).ready(() => {
    $el
      .off('change', '.change-preferred-method')
      .on('change', '.change-preferred-method', function () {
        const that = jq(this);
        const method = that.val();
        if (!method) {
          return;
        }
        const existingMethod = $el.find(
          '.payment-logo-container:visible, ' +
            '.showing-method-account-details:visible',
        );
        jq.ajax({
          url: '/ajax/user/setUserPreferedPayment.php',
          dataType: 'json',
          type: 'post',
          data: {
            method,
          },
          beforeSend() {
            that.hide();
            $el
              .find(
                '.payment-logo-container, .close-change-preferred-method, ' +
                  '.showing-method-account-details',
              )
              .hide();
            $el
              .find(
                '.loading-img-change-preferred-method, ' +
                  '.open-change-preferred-method',
              )
              .show();
            $el.find('.payments-source-generic-error').html('').hide();
            $el.closest('.modal').find('.btn').attr('disabled', true);
          },
          success(response) {
            if (response.result == 'success') {
              $el
                .find(
                  '.is-preferred, .is-preferred-separator, ' +
                    `.payment-logo-container.${method}, ` +
                    `.showing-method-account-details.${method}`,
                )
                .show();
              moduleData.preferredPaymentMethod = method;
            } else {
              $el
                .find('.payments-source-generic-error')
                .html(
                  T_(
                    'Failed to save your preferred payment method. ' +
                      'Please try again.',
                  ),
                )
                .show();
              existingMethod.show();
            }
          },
          error() {
            $el
              .find('.payments-source-generic-error')
              .html(T_('Server Error'))
              .show();
            existingMethod.show();
          },
          complete() {
            $el.find('.loading-img-change-preferred-method').hide();
            // front end delay for potential slave drift
            setTimeout(() => {
              $el.closest('.modal').find('.btn').removeAttr('disabled');
            }, 1200);
          },
        });
      });

    $el
      .off('click', '.open-change-preferred-method')
      .on('click', '.open-change-preferred-method', function () {
        jq(this).hide();
        $el.find('.is-preferred').hide();
        $el
          .find('.change-preferred-method, .close-change-preferred-method')
          .show();
      });

    $el
      .off('click', '.close-change-preferred-method')
      .on('click', '.close-change-preferred-method', function () {
        jq(this).hide();
        $el.find('.change-preferred-method').hide();
        if (moduleData.preferredPaymentMethod) {
          $el.find('.is-preferred').show();
        }
        $el.find('.open-change-preferred-method').show();
      });

    $el.find('.payment-source-tooltip.gatewayGC').popover({
      content() {
        const gatewayGCAccounts = [];
        if (moduleData.paymentMethods.gcRecurring) {
          for (
            let i = 0;
            i < moduleData.paymentMethods.gcRecurring.length;
            i++
          ) {
            gatewayGCAccounts.push(
              moduleData.paymentMethods.gcRecurring[i].cc_number,
            );
          }
        }
        return gatewayGCAccounts.join('<br>');
      },
      title: 'Credit cards',
      placement: 'top',
      html: true,
      trigger: 'hover',
    });

    $el.find('.payment-source-tooltip.gatewayWP').popover({
      content() {
        const gatewayWPAccounts = [];
        if (moduleData.paymentMethods.wpRecurring) {
          for (
            let i = 0;
            i < moduleData.paymentMethods.wpRecurring.length;
            i++
          ) {
            gatewayWPAccounts.push(
              moduleData.paymentMethods.wpRecurring[i].cc_number,
            );
          }
        }
        return gatewayWPAccounts.join('<br>');
      },
      title: T_('Credit cards'),
      placement: 'top',
      html: true,
      trigger: 'hover',
    });

    $el.find('.payment-source-tooltip.gatewayMB').popover({
      content() {
        const gatewayMBAccounts = [];
        if (moduleData.paymentMethods.skrillPaymentVerified) {
          for (
            let i = 0;
            i < moduleData.paymentMethods.skrillPaymentVerified.length;
            i++
          ) {
            gatewayMBAccounts.push(
              moduleData.paymentMethods.skrillPaymentVerified[i]
                .onetap_invoice_id,
            );
          }
        }
        return gatewayMBAccounts.join('<br>');
      },
      placement: 'top',
      html: true,
      trigger: 'hover',
    });
  });
}

function reconstructBalances() {
  // Remove balances with zero amount and set the primary balance to balance
  // with payment's currency
  for (let i = 0; i < moduleData.balances.length;) {
    moduleData.balances[i].balance = parseFloat(moduleData.balances[i].balance);
    if (moduleData.balances[i].balance == 0) {
      moduleData.balances.splice(i, 1);
    } else if (
      moduleData.balances[i].currency.id == moduleData.currencyDetails.id
    ) {
      moduleData.primaryBalanceForPayment = moduleData.balances[i];
      moduleData.balances.splice(i, 1);
    } else {
      i++;
    }
  }
  if (moduleData.primaryBalanceForPayment) {
    moduleData.balances.unshift(moduleData.primaryBalanceForPayment);
  }
}

function countVerifiedPaymentSource() {
  if (moduleData.firstAvailablePaymentMethod) {
    if (moduleData.paymentMethods.ppEmail) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.gcRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.wpRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.skrillPaymentVerified) {
      moduleData.verifiedPaymentSourceCount++;
    }
  }
}

function customizePaymentSourceNeedDepositContent() {
  if (typeof moduleData.needDepositCustomTitle !== 'undefined') {
    $el
      .closest('.modal')
      .find('.modal-header h3')
      .html(moduleData.needDepositCustomTitle);
  }

  if (typeof moduleData.needDepositCustomBody !== 'undefined') {
    $el.find('.need-deposit').html(moduleData.needDepositCustomBody);
  }
  if (
    typeof moduleData.needDepositAmountDiv !== 'undefined' &&
    !moduleData.needDepositAmountDiv
  ) {
    $el.find('.payment-from').hide();
    $el.closest('.modal-body').find('p:first').hide();
  }

  if (typeof moduleData.needDepositConfirmText !== 'undefined') {
    $el
      .closest('.modal')
      .find('.modal-footer .modal-btn-confirm-payment')
      .html(moduleData.needDepositConfirmText);
  }
  if (typeof moduleData.needDepositCancelText !== 'undefined') {
    $el
      .closest('.modal')
      .find('.modal-footer .modal-btn-cancel-payment')
      .html(moduleData.needDepositCancelText);
  }
}

export default {
  init,
  checkPaymentSource,
};
